import { Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../../../localization'
import { DetailedRoomStays } from '../../../../types/cart'
import { Currency } from '../../../../types/currency'
import RoomStayPriceDetails from './RoomStayPriceDetails'
import { useStyles } from './styles/index.styles'

type PriceDetailsProps = {
  detailedRoomStays: DetailedRoomStays[] | undefined
  curruncy: Currency
}

const PriceDetails: React.FC<PriceDetailsProps> = ({
  detailedRoomStays,
  curruncy
}: PriceDetailsProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography className={classes.sectionTitle}>
          {getTranslate('Price Details')}
        </Typography>
      </div>
      <Divider />
      {isMobile ? (
        <div className={classes.scrollWrapper}>
          <div className={classes.scrollRow}>
            <div className={classes.content}>
              <RoomStayPriceDetails
                detailedRoomStays={detailedRoomStays || []}
                curruncy={curruncy}
              />
              {/* <TaxAndFeeDetails /> */}
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.content}>
          <RoomStayPriceDetails
            detailedRoomStays={detailedRoomStays || []}
            curruncy={curruncy}
          />
          {/* <TaxAndFeeDetails /> */}
        </div>
      )}
    </div>
  )
}

export default PriceDetails
